<script setup lang="ts">
export type Props = {
  rating: number
}
const props = defineProps<Props>()

const stars = computed(() => [1, 2, 3, 4, 5].map((i) => {
  return {
    star: i,
    on: i <= Math.floor(props.rating),
    partial: i === Math.floor(props.rating) + 1,
    off: i > Math.ceil(props.rating),
    style: i === Math.floor(props.rating) + 1
      ? `--percentage: ${Math.round((props.rating - i + 1) * 100)}%;`
      : undefined,
  }
}))
</script>

<template>
  <div class="review-stars">
    <span
      v-for="star in stars"
      :key="`score-start-${star.star}`"
      class="review-stars__star"
      :style="star.style"
      :class="{
        'review-stars__star--on': star.on,
        'review-stars__star--partial': star.partial,
        'review-stars__star--off': star.off,
      }"
    >
      <NuxtIcon name="icon:star" />
    </span>
  </div>
</template>

<style>
@import url("~layers/components/Review/Stars.css");
</style>
